export const noop = (...args: any[]) => { return; };